import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { TenantsComponent } from "./tenants/tenants.component";
import { EnvironmentsComponent } from "./environments/environments.component";
import { ServicesComponent } from "./services/services.component";
import { ConfigurationComponent } from "./configuration.component";

const routes: Routes = [
  {
    path: "configuration",
    component: ConfigurationComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: "tenants",
        component: TenantsComponent,
        canActivate: [MsalGuard]
      },
      {
        path: "environments",
        component: EnvironmentsComponent,
        canActivate: [MsalGuard]
      },
      {
        path: "services",
        component: ServicesComponent,
        canActivate: [MsalGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigurationRoutingModule {}
